import { CustomerFormValues, CustomerStaffFormValues } from "./CustomerForm.types"

export const INIT_STAFF: CustomerStaffFormValues = {
  displayName: "",
  email: "",
  telephone: "",
  useNotification: {
    kakaoTalk: false,
    email: true,
  },
}

export const INIT_CUSTOMER: CustomerFormValues = {
  businessRegistrationNumber: "",
  organizationName: "",
  representativeName: "",
  address: "",
  memo: "",
  taxRegistrationId: "",
  businessType: "",
  businessItem: "",
  staffs: [INIT_STAFF],
}
